"use strict";
import React from "react";
import ReactDOM from "react-dom";
import $ from "jquery";
import Account from "../api/account";
import DisablingButton from "./disabling_button";
import DocumentBrowserMainImage from "./document_browser/main_image";
import DocumentBrowserShell from "./document_browser/shell";
import DocumentThumbnailList from "./document_thumbnail_list";
import FactorInvoicesService from "./factor_invoices_service";
import FactorBrokersService from "./factor_brokers_service";
import model from "./document_group_editor_model";
import format from "../formatters/general";
import reactUtils from "../react_utils";
import * as popout from "./popout";
import _ from "underscore";
import {
  GroupedDocumentBrowserModel,
  UngroupedGroupCreator
} from "./grouped_document_browser_model";
var bem = reactUtils.makeBem("document-group-editor");
function hashFn(key, value) {
  var dictionary = {};
  dictionary[key] = value;
  return dictionary;
}
function mapHashValues(hash, mappingFunction) {
  return _.chain(hash).map(function(value, key) {
    return hashFn(key, mappingFunction(value));
  }).reduce(function(memo, value) {
    return _.extend(memo, value);
  }).value();
}
function initialErrorDisplay(documentGroups) {
  const errorDisplay = {};
  documentGroups.forEach((group) => {
    errorDisplay[group.id] = true;
  });
  return errorDisplay;
}
function isApproved(invoiceId) {
  const invoice = FactorInvoicesService.getFetchedWithId(invoiceId);
  return invoice.state === "approved";
}
function canBeRejected(invoiceId, reason) {
  return !isApproved(invoiceId) && (reason === "exceptions" || reason == "processed_factor_invoice");
}
function classForGroup(position) {
  return bem({
    __group: true,
    "__group--new": position === "new",
    "__group--ungrouped-browser": position === "ungrouped-browser"
  });
}
function shouldMaintainNumberOfGroups() {
  return Account.currentSettings().submissionWorkflow;
}
function unassociatedDocumentsAllowed() {
  return Account.currentSettings().index_audit_split_enabled && Account.isType("factor_account");
}
function shouldShowNewGroup() {
  return !shouldMaintainNumberOfGroups();
}
function groupTitle(position) {
  if (position === "ungrouped-browser") {
    return "Ungrouped Browser";
  } else if (position === "unassociated") {
    return "Unassociated";
  } else if (position === "new") {
    return "New Group";
  } else {
    return "Group " + position;
  }
}
function idsOrderedByPositionIn(originalCollection, collection) {
  var originalPosition = _.partial(_.indexOf, originalCollection);
  return _.chain(collection).sortBy(originalPosition).map(_.property("id")).value();
}
function documentIdsOrderedByPositionIn(documents) {
  return _.partial(idsOrderedByPositionIn, documents);
}
function pageIsSelected(state, page) {
  return !_.isEmpty(state.selectedPages.find((p) => p.id === page.id));
}
function selectedPage(state) {
  return state.selectedPages[0];
}
function documentsForGroup(props, state, position) {
  const group = model.group(state.documentGroups, position);
  if (group) {
    return _.map(group.documentIds, (id) => documentWithId(props, id));
  } else {
    return [];
  }
}
function documentBrowserModel(props, state) {
  const ungroupedBrowserGroupCreator = new UngroupedGroupCreator(
    props.documentBatch.documents
  );
  return new GroupedDocumentBrowserModel(
    ungroupedBrowserGroupCreator,
    function() {
      return false;
    },
    selectedPage(state)
  );
}
function possibleInvoiceInformation(props, group) {
  if (group.factorInvoiceId) {
    const factorInvoice = FactorInvoicesService.getFetchedWithId(
      group.factorInvoiceId
    );
    if (!factorInvoice) return;
    const maybeLoadId = factorInvoice.load_id;
    const maybeDebtor = factorInvoice.factor_broker_id && FactorBrokersService.getFetchedWithId(factorInvoice.factor_broker_id);
    if (!maybeLoadId && !maybeDebtor) return;
    const documentIdsNotInThisBatch = _.difference(
      factorInvoice.document_ids,
      _.pluck(props.documentBatch.documents, "id")
    );
    const displayAmount = factorInvoice.source_invoice_amount ? format.currency(factorInvoice.source_invoice_amount) : null;
    let maybeOtherDocumentsMessage = null;
    if (!_.isEmpty(documentIdsNotInThisBatch)) {
      if (documentIdsNotInThisBatch.length === 1) {
        maybeOtherDocumentsMessage = "and 1 document from another message";
      } else {
        maybeOtherDocumentsMessage = `and ${documentIdsNotInThisBatch.length} documents from other messages`;
      }
    }
    const displayState = {
      approved: "Approved",
      processed: "Processed",
      auto_processed: "Auto Processed",
      verified: "Approved",
      draft: "Draft",
      needs_indexing: "Draft",
      //Intentional
      exception: "Incomplete"
    }[factorInvoice.state] || "Incomplete";
    return /* @__PURE__ */ React.createElement("span", null, displayState + " invoice", displayAmount ? ` of ${displayAmount}, ` : ",", maybeDebtor ? " for " + maybeDebtor.name + " " : "", maybeLoadId ? " for load " + maybeLoadId + " " : "", maybeOtherDocumentsMessage);
  }
}
function leftCancelLink(props) {
  if (props.canCancel) {
    return /* @__PURE__ */ React.createElement("span", { className: "button--left-cancel-wrapper" }, /* @__PURE__ */ React.createElement(
      "button",
      {
        onClick: props.onCancel,
        className: "button--cancel document-group-editor__cancel-button"
      },
      "cancel"
    ), /* @__PURE__ */ React.createElement("span", { className: "button--left-cancel-or" }, "or"));
  }
}
function allDocumentsAreGrouped(state) {
  return model.allDocumentsAreGrouped(state.documentGroups);
}
function groupsFromDocumentBatch(props, documentBatch) {
  var documentIdsByGroup = _.chain(documentBatch.documents).groupBy((doc) => doc.data.group_id || "ungrouped-browser").value();
  documentIdsByGroup = mapHashValues(
    documentIdsByGroup,
    documentIdsOrderedByPositionIn(documentBatch.documents)
  );
  const groupsOrderedByPosition = _.sortBy(
    documentBatch.document_groups,
    "position"
  );
  const groups = _.chain(groupsOrderedByPosition).mapObject((documentGroup, i) => {
    const documentIds = documentIdsByGroup[documentGroup.position] || [];
    const firstDocument = documentWithId(props, _.first(documentIds));
    return {
      position: documentGroup.position,
      documentIds,
      factorInvoiceId: firstDocument == null ? void 0 : firstDocument.factor_invoice_id,
      id: documentGroup.id,
      locked: !!documentGroup.locked,
      lockedReason: documentGroup.locked_reason
    };
  }).tap((gs) => {
    const onlyHasUngroupedBrowserDocuments = _.keys(documentIdsByGroup).length === 1 && _.keys(documentIdsByGroup)[0] === "ungrouped-browser";
    if (onlyHasUngroupedBrowserDocuments) {
      gs[0] = {
        position: 1,
        documentIds: [].concat(
          documentIdsByGroup["ungrouped-browser"].shift()
        ),
        id: null,
        locked: false,
        lockedReason: null
      };
    }
    if (!gs["unassociated"] && unassociatedDocumentsAllowed()) {
      gs["unassociated"] = {
        position: "unassociated",
        documentIds: documentIdsByGroup["unassociated"],
        id: null,
        locked: false,
        lockedReason: null
      };
    }
    if (!gs["ungrouped-browser"]) {
      gs["ungrouped-browser"] = {
        position: "ungrouped-browser",
        documentIds: documentIdsByGroup["ungrouped-browser"],
        id: null,
        locked: false,
        lockedReason: null
      };
    }
  }).value();
  return shouldShowNewGroup() ? _.values(groups).concat(model.buildNewGroup()) : _.values(groups);
}
function documentWithId(props, documentId) {
  return _.findWhere(props.documentBatch.documents, { id: documentId });
}
var DocumentGroupEditor = React.createClass({
  getInitialState: function() {
    const documentGroups = groupsFromDocumentBatch(this.props, this.props.documentBatch);
    return {
      documentGroups,
      documentIds: this.props.documentBatch.documents.map((d) => d.id).sort(),
      originalDocumentIds: this.props.documentBatch.documents.map((d) => d.id).sort(),
      saving: this.props.saving,
      selectedPages: [],
      anchorPage: null,
      errorDisplay: initialErrorDisplay(documentGroups)
    };
  },
  componentDidMount: function() {
    const component = this;
    const container = $(ReactDOM.findDOMNode(this.refs.container));
    _.each(
      container.find(".document-thumbnail-list, ." + bem("__new-group-target")),
      function(element) {
        if (!$(element).droppable("instance")) {
          $(element).droppable({ hoverClass: bem("__list--active") });
        }
        if (!$(element).sortable("instance")) {
          $(element).sortable({
            connectWith: [
              ".document-thumbnail-list",
              "." + bem("__new-group-target")
            ],
            start: function(event, ui) {
              const documentId = ui.item.find(".document-thumbnail").attr("data-document-id");
              const currentPage = _.findWhere(
                component.props.documentBatch.documents,
                { id: Number(documentId) }
              ).pages[0];
              if (!pageIsSelected(component.state, currentPage)) {
                component.setSelectedPages([currentPage], currentPage);
              }
            },
            update: function(event, ui) {
              const documentMovedWithinSameGroup = this === ui.item.parent()[0];
              if (documentMovedWithinSameGroup) {
                component.documentMoved(ui.item.parent());
              } else {
              }
            },
            receive: function(event, ui) {
              component.documentMoved(ui.sender);
            }
          });
        }
      }
    );
    this.preventEditingExceptionedGroups();
    this.preventEditingWhenLeftDocument();
  },
  componentWillReceiveProps: function(newProps) {
    const newState = _.tap({}, (state) => {
      if (newProps.saving !== this.props.saving) {
        state.saving = newProps.saving;
      }
      const newDocumentIds = newProps.documentBatch.documents.map((d) => d.id).sort();
      if (!_.isEqual(this.state.documentIds, newDocumentIds)) {
        state.documentIds = newDocumentIds;
        const addedDocIds = _.difference(
          newDocumentIds,
          this.state.documentIds
        );
        if (addedDocIds.length > 0) {
          const addedDocuments = addedDocIds.map(
            (id) => newProps.documentBatch.documents.find((doc) => doc.id === id)
          );
          const parentDocs = addedDocuments.map(
            (addedDoc) => newProps.documentBatch.documents.find(
              (doc) => addedDoc.copied_from_id && doc.id === addedDoc.copied_from_id
            )
          );
          const updatedDocumentGroups = _.tap(
            model.groupsFromDomSnapshot(
              this.domSnapshot(),
              shouldShowNewGroup(),
              !shouldMaintainNumberOfGroups()
            ),
            (groups) => {
              _.each(_.zip(addedDocuments, parentDocs), ([doc, parentDoc]) => {
                const parentGroupKey = _.findKey(
                  groups,
                  (g) => g.documentIds.find((id) => parentDoc && id === parentDoc.id)
                );
                if (parentGroupKey) {
                  groups[parentGroupKey].documentIds.push(doc.id);
                }
              });
            }
          );
          state.documentGroups = updatedDocumentGroups;
        }
      }
    });
    if (!_.isEmpty(newState)) {
      this.setState(newState);
    }
  },
  componentDidUpdate: function() {
    this.componentDidMount();
  },
  disableEditingForRef: function(ref) {
    var element = $(ReactDOM.findDOMNode(this.refs[ref]));
    $(element).sortable("disable");
    $(element).droppable("disable");
  },
  preventEditingWhenLeftDocument: function() {
    var component = this;
    if (this.state.leftSelected) {
      var groups = this.state.documentGroups;
      _.each(groups, function(v) {
        var ref = "group-" + v.position;
        component.disableEditingForRef(ref);
      });
      component.disableEditingForRef("left-document-browser");
    }
  },
  preventEditingExceptionedGroups: function() {
    var component = this;
    var groups = this.state.documentGroups;
    _.each(groups, (grp) => {
      var ref = "group-" + grp.position;
      var element = $(ReactDOM.findDOMNode(component.refs[ref]));
      if (grp.locked) {
        $(element).sortable("disable");
        $(element).droppable({
          drop: _.partial(
            (event, ui, id) => {
              this.toggleExceptionDisplay(id, true);
            },
            _,
            _,
            grp.id
          )
        });
      } else {
        $(element).sortable("enable");
        $(element).droppable("enable");
      }
    });
  },
  documentMoved: function(sortableElement) {
    const documentGroups = model.groupsFromDomSnapshot(
      this.domSnapshot(),
      shouldShowNewGroup(),
      !shouldMaintainNumberOfGroups()
    );
    sortableElement.sortable("cancel");
    this.setState({ documentGroups });
  },
  groupsOrLeftDocument: function() {
    var documents = null;
    var styles = {};
    var groups = model.groups(this.state.documentGroups);
    groups = _.reject(groups, function(g) {
      return g.position === "ungrouped-browser" || g.position === null;
    });
    if (this.state.leftSelected) {
      var groupId = this.state.leftSelected.groupId;
      var page = this.state.leftSelected.page;
      documents = this.showDocumentBrowser(
        groupId,
        page,
        _.partial(this.openThumbnailLeft, groupId),
        "Group " + groupId
      );
      styles = { display: "none" };
      groups = _.reject(groups, (g) => g.position === groupId);
    }
    return /* @__PURE__ */ React.createElement("div", { className: bem("__groups") }, /* @__PURE__ */ React.createElement("div", { className: bem("__groups-container"), ref: "groupsContainer" }, documents, /* @__PURE__ */ React.createElement("div", { style: styles }, _.map(groups, this.group))));
  },
  showDocumentBrowser: function(groupId, selectedPage2, callback, title) {
    return this.documentBrowserShell(
      groupId,
      selectedPage2,
      callback,
      title,
      "left-document-browser"
    );
  },
  documentBrowserShell(groupId, selectedPage2, callback, title, ref) {
    return /* @__PURE__ */ React.createElement(
      DocumentBrowserShell,
      {
        mainImageTitle: "Current Document",
        closeLink: this.possibleCloseLink(title),
        documentsTitle: title
      },
      /* @__PURE__ */ React.createElement(
        DocumentBrowserMainImage,
        {
          page: selectedPage2,
          model: documentBrowserModel(this.props, this.state),
          allowsEditing: true,
          allowsSplitMerge: false,
          toggleDocumentData: this.props.toggleDocumentData,
          toggleMarkIllegibleData: this.props.toggleMarkIllegibleData,
          toggleHiddenData: this.props.toggleHiddenData,
          allowsEditingPodStatus: true
        }
      ),
      /* @__PURE__ */ React.createElement("div", { className: "document-browser__document-list" }, /* @__PURE__ */ React.createElement(
        DocumentThumbnailList,
        {
          documents: documentsForGroup(this.props, this.state, groupId),
          onContextMenu: _.partial(this.openThumbnailLeft, groupId),
          ref,
          key: "react-editor-groups-" + groupId,
          setSelectedPages: this.setSelectedPages,
          selectedPages: this.state.selectedPages,
          anchorPage: this.state.anchorPage,
          isDocumentGrouper: true
        }
      ))
    );
  },
  possibleCloseLink: function(title) {
    if (title !== "ungrouped-browser") {
      return /* @__PURE__ */ React.createElement("a", { onClick: this.closeLeftSideBrowser }, /* @__PURE__ */ React.createElement("i", { className: "fi-x-circle" }));
    }
  },
  closeLeftSideBrowser: function() {
    this.setState({ leftSelected: null });
  },
  possibleActionBar: function() {
    if (!this.state.leftSelected) {
      return this.rightActionButtons(bem);
    }
  },
  rightActionButtons: function() {
    return /* @__PURE__ */ React.createElement("div", { className: bem("__action-bar") + " " + bem("__action-bar--right") }, /* @__PURE__ */ React.createElement("div", { className: bem("__help-text-container") }, /* @__PURE__ */ React.createElement("div", { className: bem("__help-text") }, "Right click thumbnails to view full size document")), /* @__PURE__ */ React.createElement("div", { className: bem("__buttons") }, leftCancelLink(this.props), this.button()));
  },
  render: function() {
    return /* @__PURE__ */ React.createElement("div", { "data-component": "DocumentGroupEditor", className: bem(), ref: "container" }, /* @__PURE__ */ React.createElement("div", { className: bem("__thumbnails") }, this.possibleActionBar(), this.groupsOrLeftDocument()), /* @__PURE__ */ React.createElement("div", { className: bem("__preview") }, this.documentBrowserShell(
      "ungrouped-browser",
      selectedPage(this.state),
      function() {
      },
      "ungrouped-browser",
      "group-ungrouped-browser"
    )));
  },
  group: function(documentGroup) {
    const documents = _.map(
      documentGroup.documentIds,
      (id) => documentWithId(this.props, id)
    );
    const { locked, lockedReason, position } = documentGroup;
    return /* @__PURE__ */ React.createElement("div", { className: classForGroup(position), key: "group-" + position }, /* @__PURE__ */ React.createElement("div", { className: bem("__group-title") }, /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "small-1 column" }, /* @__PURE__ */ React.createElement("span", { style: { whiteSpace: "nowrap" } }, groupTitle(position))), /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "small-5 column " + bem("__group-invoice-information")
      },
      possibleInvoiceInformation(this.props, documentGroup)
    ), /* @__PURE__ */ React.createElement("div", { className: "small-3 column" }, this.possibleExceptionHelpText(
      documentGroup,
      locked,
      lockedReason
    )), /* @__PURE__ */ React.createElement("div", { className: "small-1 column " + bem("__locked-group-icon") }, this.possibleExceptionIcon(locked, documentGroup)))), /* @__PURE__ */ React.createElement(
      DocumentThumbnailList,
      {
        documents,
        ref: "group-" + position,
        key: "react-editor-groups-" + position,
        variant: "--horizontal",
        onContextMenu: _.partial(this.openThumbnailLeft, position),
        setSelectedPages: this.setSelectedPages,
        anchorPage: this.state.anchorPage,
        selectedPages: this.state.selectedPages,
        isDocumentGrouper: true
      }
    ));
  },
  possibleExceptionIcon: function(locked, documentGroup) {
    if (locked) {
      return /* @__PURE__ */ React.createElement(
        "i",
        {
          onClick: _.partial(
            this.toggleExceptionDisplay,
            documentGroup.id,
            false
          ),
          className: "fi-lock small"
        }
      );
    }
  },
  toggleExceptionDisplay: function(documentGroupId, override) {
    const display = Object.assign({}, this.state.errorDisplay);
    display[documentGroupId] = override || !display[documentGroupId];
    this.setState({ errorDisplay: display });
  },
  setSelectedPages: function(selectedPages, anchorPage) {
    this.setState({ selectedPages, anchorPage }, () => {
      if (anchorPage) {
        const documentPageId = anchorPage.id;
        popout.setSinglePageId(documentPageId);
      } else {
        popout.setEmptySelection();
      }
    });
  },
  possibleExceptionHelpText: function(group, hasExceptions, reason = null) {
    if (hasExceptions && this.state.errorDisplay[group.id]) {
      const invoiceId = group.factorInvoiceId;
      const reasons = {
        exceptions: "This group cannot be modified because it has an exception.",
        processed_factor_invoice: "This group cannot be modified because it has a processed invoice.",
        processed_carrier_invoice: "This group cannot be modified because it has a processed invoice.",
        incomplete_factor_invoice: "This group cannot be modified because it has an incomplete invoice.",
        has_factor_client_invoice_submission: "This group cannot be modified because it was submitted via the Client Portal."
      };
      const reasonText = (
        // @ts-expect-error - TODO: fix TypeScript error
        reasons[reason] || "This group cannot be modified because it has an exception."
      );
      return /* @__PURE__ */ React.createElement("div", { className: "alert-box--caution document-group-editor__group-exception-alert " }, /* @__PURE__ */ React.createElement("div", null, reasonText, "\xA0"), this.possibleRejectInvoiceButton(invoiceId, reason));
    }
  },
  possibleRejectInvoiceButton: function(invoiceId, reason) {
    if (invoiceId && canBeRejected(invoiceId, reason)) {
      return /* @__PURE__ */ React.createElement(
        "button",
        {
          onClick: _.partial(this.rejectInvoice, invoiceId),
          className: "button " + bem("__reject-button")
        },
        "Reject Invoice"
      );
    }
  },
  rejectInvoice: function(invoiceId) {
    this.setState({ saving: true });
    var component = this;
    FactorInvoicesService.rejectInvoice(invoiceId).then((data) => {
      const groups = _.map(component.state.documentGroups, (group) => {
        if (group.factorInvoiceId === data.id) {
          group.locked = false;
          group.lockedReason = null;
          return group;
        } else {
          return group;
        }
      });
      this.setState({ documentGroups: groups, saving: false });
    });
  },
  openThumbnailLeft: function(position, page) {
    this.setState({ leftSelected: { groupId: position, page } });
  },
  button: function() {
    if (allDocumentsAreGrouped(this.state)) {
      return /* @__PURE__ */ React.createElement(
        DisablingButton,
        {
          disabled: this.state.saving,
          className: "button--progress document-group-editor__continue-button",
          onClick: this.onContinue,
          disabledText: "Saving..."
        },
        "Continue"
      );
    } else {
      return /* @__PURE__ */ React.createElement("a", { className: "button--disabled document-group-editor__disabled-button" }, "All documents must be grouped to continue");
    }
  },
  onContinue: function() {
    this.setState({ saving: true });
    this.props.onContinue(
      model.actualGroups(this.state.documentGroups),
      this.state.originalDocumentIds
    );
  },
  domSnapshot: function() {
    return _.map(
      model.groups(this.state.documentGroups),
      this.groupAndDocumentIdPairsFromDom
    );
  },
  groupAndDocumentIdPairsFromDom: function(group) {
    var ref = this.refs["group-" + group.position];
    var documentNodes = $(ReactDOM.findDOMNode(ref)).find(
      ".document-thumbnail"
    );
    documentNodes = _.reject(documentNodes, function(node) {
      return _.isUndefined($(node).attr("data-document-id"));
    });
    var newDocumentIds = _.map(documentNodes, function(documentNode) {
      return Number($(documentNode).attr("data-document-id"));
    });
    return [group, newDocumentIds];
  }
});
export default DocumentGroupEditor;
